var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthDiaryViewTemperatureEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffaed9;}.cls-3{fill:#fce3f1;}.cls-4{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_131",
    "data-name": "Layer 131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.94,585.56a121.55,121.55,0,0,1-71.27-220l6.2-4.49V81.12a64.38,64.38,0,1,1,128.76,0V360.18l6.36,4.48a121.56,121.56,0,0,1-70.05,220.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.25,31.73a49.44,49.44,0,0,1,49.38,49.38V368l12.72,9a106.64,106.64,0,1,1-123.89.77l12.41-9V81.11a49.44,49.44,0,0,1,49.38-49.38m0-30a79.47,79.47,0,0,0-79.38,79.38V353.39A136.27,136.27,0,0,0,165.39,464c0,75.29,61.25,136.55,136.55,136.55S438.48,539.3,438.48,464A136,136,0,0,0,380.63,352.4V81.11A79.47,79.47,0,0,0,301.25,1.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 265.57,
    y: 50.74,
    width: 72.6,
    height: 301.7,
    rx: 36.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M337.7,376.07V181.91a36.45,36.45,0,0,0-36.45-36.45h0a36.45,36.45,0,0,0-36.45,36.45V376.64a94.91,94.91,0,1,0,72.9-.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 258.28,
    cy: 431.18,
    rx: 27.36,
    ry: 16.25,
    transform: "translate(-234.8 333.73) rotate(-47.9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryViewTemperatureEntries);
export default __webpack_public_path__ + "static/media/health_diary_view_temperature_entries.12fb5162509e396eb1124a35fc34cf72.svg";
export { ForwardRef as ReactComponent };